import {
    DataTable,
    DateField,
    ExportButton,
    List,
    ReferenceField,
    TextField
} from '@/components/admin';
import { Card } from '@/components/ui/card';
import { Calendar } from 'lucide-react';
import { useRecordContext } from 'ra-core';
import { TopToolbar } from '../../layout/TopToolbar';
import { PermissionCreateButton } from '../shared/PermissionCreateButton';
import { StatusBadge } from '../shared/StatusBadge';

const StatusCell = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <StatusBadge status={record.status} />;
};

const AmountCell = () => {
    const record = useRecordContext();
    if (!record?.total_amount) return <span className="text-muted-foreground text-xs">—</span>;
    return (
        <div className="flex items-center gap-1 font-bold text-success">
            {new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(record.total_amount)}
        </div>
    );
};

const PIListActions = () => (
    <TopToolbar>
        <ExportButton />
        <PermissionCreateButton permission="manage_documents" label="New PI" />
    </TopToolbar>
);

import { getGlobalFilters } from '../shared/GlobalFilterBar';

const piStatusChoices = [
    { id: 'draft', name: 'Draft' },
    { id: 'sent', name: 'Sent' },
    { id: 'approved', name: 'Approved' },
    { id: 'rejected', name: 'Rejected' },
];

export const PIList = () => (
    <List
        title="Proforma Invoices"
        actions={<PIListActions />}
        filters={getGlobalFilters(piStatusChoices, "PI Status")}
        sort={{ field: 'date', order: 'DESC' }}
        className="p-6"
        filtersLayout="two-rows"
    >
        <Card className="border-none shadow-sm overflow-hidden">
            <DataTable rowClick="show">
                <DataTable.Col
                    source="reference"
                    label="Proforma Invoice No."
                    className="font-mono font-bold text-primary"
                />
                <DataTable.Col label="Company">
                    <ReferenceField source="company_id" reference="companies" link={false}>
                        <TextField source="name" className="font-semibold text-foreground" />
                    </ReferenceField>
                </DataTable.Col>
                <DataTable.Col source="customer_name" label="Customer" className="text-sm" />
                <DataTable.Col label="Date">
                    <div className="flex items-center gap-2 text-muted-foreground text-xs">
                        <Calendar className="w-3 h-3" />
                        <DateField source="date" />
                    </div>
                </DataTable.Col>
                <DataTable.Col label="Status">
                    <StatusCell />
                </DataTable.Col>
                <DataTable.Col label="Total">
                    <AmountCell />
                </DataTable.Col>
                <DataTable.Col label="Created">
                    <DateField source="created_at" showTime showDate />
                </DataTable.Col>
            </DataTable>
        </Card>
    </List>
);
